import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getConfig } from '../api/config';
import { initiateLogin } from '../auth/oidc';
import { useAuth } from '../auth/useAuth';

export default function LoginPage() {
  const { role, accessToken, email } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  // Already logged in — go to admin
  useEffect(() => {
    if (role !== 'public') {
      navigate('/admin', { replace: true });
    }
  }, [role, navigate]);

  const handleLogin = async () => {
    try {
      await initiateLogin(await getConfig());
    } catch {
      setError('Could not initiate login. Please try again.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Sign in</h1>
        <p>Access to admin and developer features requires a SkyMap Docs account.</p>
        {accessToken && role === 'public' && (
          <p className="login-error">
            You are signed in{email ? ` as ${email}` : ''}, but no docs role is assigned to your
            account. Ask a docs admin to grant you one, then sign in again.
          </p>
        )}
        {error && <p className="login-error">{error}</p>}
        <button className="btn-primary" onClick={() => void handleLogin()}>
          Continue with SkyMap SSO
        </button>
      </div>
    </div>
  );
}
